export default __webpack_public_path__ + "7f3cde7ca263651fae517d9a0919df30.svg";